module.exports = __webpack_public_path__ + "static/media/frmlogonew.ba072782.png";